import { SVGProps } from 'react'

export const CardSliderFooterWingsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="89rem"
      height="33rem"
      viewBox="0 0 89 33"
      fill="none"
      {...props}
    >
      <g opacity="0.5">
        <path
          d="M97.8633 2.5249C101.644 2.18724 105.491 1.92259 109.394 1.73291L26.2734 0.23291L26.2627 1.23291L97.8633 2.5249ZM68.375 6.86377C69.7038 6.58389 71.0467 6.31339 72.4033 6.05322L22.2471 3.68018L22.2168 4.68018L68.375 6.86377ZM53.2354 10.6489C54.1463 10.3821 55.0667 10.1205 55.9961 9.86377L18.6406 6.9165C18.4783 7.23941 18.3132 7.5607 18.1455 7.88037L53.2354 10.6489ZM42.4082 14.2202C43.1101 13.9606 43.8187 13.7026 44.5352 13.4497L16.7607 10.3784C16.5762 10.6941 16.3901 11.0087 16.2002 11.3208L42.4082 14.2202ZM33.873 17.7026C34.4429 17.446 35.019 17.1916 35.6016 16.9399L14.5176 13.936C14.3083 14.2443 14.0964 14.5506 13.8818 14.855L33.873 17.7026ZM26.8242 21.1802C27.298 20.9239 27.7773 20.6689 28.2627 20.4165L11.8672 17.5562C11.6317 17.8547 11.3931 18.1507 11.1523 18.4448L26.8242 21.1802ZM20.8564 24.7144C21.2529 24.4567 21.654 24.1993 22.0615 23.9448L8.76367 21.1958C8.49976 21.4825 8.23401 21.7676 7.96484 22.0493L20.8564 24.7144ZM15.7529 28.3638C16.0844 28.1018 16.4203 27.8398 16.7627 27.5806L5.16113 24.8042C4.86558 25.0772 4.56837 25.3484 4.26758 25.6157L15.7529 28.3638ZM11.4053 32.188C11.678 31.9188 11.9555 31.6501 12.2393 31.3833L1.00098 28.3257C0.670018 28.582 0.336197 28.8347 0 29.0845L11.4053 32.188Z"
          fill="url(#paint0_linear_2343_6947)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2343_6947"
          x1="15.7472"
          y1="-40"
          x2="83.7715"
          y2="3.39434"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.367094" stopColor="#B5B5B5" stopOpacity="0" />
          <stop offset="0.621292" stopColor="#B5B5B5" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
